module.exports = "dep";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/local-modules/dep.js
 ** module id = 1
 ** module chunks = 0
 **/